// Client-side wishlist helper using localStorage.
// Used by ProductCard heart button.

export function getUserIdFromLocalStorage() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.id ?? parsed?.user?.id ?? null;
  } catch {
    return null;
  }
}

function getWishlistKey(userId) {
  return `wishlist_${userId || 'guest'}`;
}

export function loadWishlistIds(userId) {
  const key = getWishlistKey(userId);
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveWishlistIds(userId, ids) {
  const key = getWishlistKey(userId);
  localStorage.setItem(key, JSON.stringify(ids));
}

export function isWishlisted(productId, userId = getUserIdFromLocalStorage()) {
  const ids = loadWishlistIds(userId);
  return ids.includes(productId);
}

export function toggleWishlist(product) {
  const userId = getUserIdFromLocalStorage();
  const id = product?.id;
  if (!id) return { wished: false, ids: [] };

  const ids = loadWishlistIds(userId);
  const exists = ids.includes(id);
  const next = exists ? ids.filter((x) => x !== id) : [...ids, id];

  // de-dupe
  const uniq = Array.from(new Set(next));
  saveWishlistIds(userId, uniq);

  return { wished: !exists, ids: uniq };
}

